import { Box } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useSideBarStyle } from './components/Style';

export default function AuthLayout() {
  const { classes, cx } = useSideBarStyle();

  return (
    <>
      <Box w={'50%'} className={classes.cornerWrapper}></Box>
      <Outlet />
    </>
  );
}
